import { Component, ViewChild, Renderer2 } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Content } from 'ionic-angular';
import { IonicPage, NavController } from 'ionic-angular';
import { ISubscription } from 'rxjs/Subscription';

import { ProofAfterEndPage } from '../proof-after-end/proof-after-end';

import { AlertProvider } from '../../providers/alert/alert';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { ProofProvider } from '../../providers/proof/proof';
import { ProofCameraProvider } from '../../providers/proof-camera/proof-camera';
import { ProofAudioProvider } from '../../providers/proof-audio/proof-audio';
import { DateTimeProvider } from '../../providers/datetime/datetime';
import { SystemProvider } from '../../providers/system/system';

import { ITimer } from '../../interfaces/itimer/itimer';

import { QuestionSituation } from '../../models/questionsituation';
import { Storage } from '@ionic/storage';
import { MediaProvider } from '../../providers/media/media';
import { ProofServerProvider } from '../../providers/proof-server/proof-server';

/**
 * Generated class for the ProofOnAppPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-on-app',
  templateUrl: 'proof-on-app.html',
})
export class ProofOnAppPage {

  @ViewChild(Content) content: Content;

  private proofFinished: boolean;
  private paused: boolean;
  private screenshotListener: any;
  private pauseSubscribe: ISubscription;
  private resumeSubscribe: ISubscription;

  answer: string;
  question: any;
  questionIdx: number;
  questionsTotal: number;
  questionSeconds: number;

  // Timer stuff
  private timeInSeconds: number;
  timer: ITimer;

  constructor(
    private navCtrl: NavController,
    private alertProvider: AlertProvider,
    private networkMonitor: NetworkMonitorProvider,
    private platform: Platform,
    private proofProvider: ProofProvider,
    private proofCameraProvider: ProofCameraProvider,
    private proofAudioProvider: ProofAudioProvider,
    private renderer: Renderer2,
    private dateTimeProvider: DateTimeProvider,
    private systemProvider: SystemProvider,
    private storage: Storage,
    private proof: ProofProvider,
    private mediaProvider: MediaProvider,
    private proofServerProvider: ProofServerProvider,

  ) {
    this.proofFinished = false;
    this.paused = false;

    this.answer = null;
    this.question = proofProvider.getCurrentQuestion();
    this.questionIdx = proofProvider.getCurrentQuestionIdx();
    this.questionsTotal = proofProvider.getQuestionsTotal();
    this.questionSeconds = 0;

    this.prepareTimer();
    this.prepareNetworkMonitor();
    this.prepareScreenshotListener();
    this.prepareCamera();
    this.prepareAudio();
  }

  private prepareTimer() {
    let that = this;

    this.timeInSeconds = 0;
    this.initTimer();

    this.proofProvider.getDuration().then((duration: any) => {
      that.timeInSeconds = duration;

      that.initTimer();
      that.startTimer();
    });
  }

  private prepareNetworkMonitor() {
    let that = this;

    this.networkMonitor.setCallback((isOnline: boolean, isWifi: boolean, isAirplaneMode: boolean) => {
      console.log('ProofOnAppPage - Online: ' + ((isOnline) ? 'Y' : 'N'));

      if ((isOnline) && (!that.platform.is('ios'))) {
        let situation = new QuestionSituation();
        situation.kind = 'QTS';
        situation.id = that.question.id;
        situation.captured = this.dateTimeProvider.getISOString();
        situation.action = 'EFFM'; // 'ExitedFromFligtMode';
        that.proofProvider.addSituation(situation);

        that.alertProvider.doAlert('Você saiu do modo avião. Sendo assim, sua prova será encerrada imediatamente.', 'Atenção', () => {
          that.systemProvider.close();
        });
      }
    });
  }

  private prepareScreenshotListener() {
    let that = this;

    this.screenshotListener = this.renderer.listen('document', 'screenshot', (evt) => {
      console.log('ProofOnAppPage - Took Screenshot');

      let situation = new QuestionSituation();
      situation.kind = 'QTS';
      situation.id = that.question.id;
      situation.captured = this.dateTimeProvider.getISOString();
      situation.action = 'TKSS'; // 'TookScreenshot';
      that.proofProvider.addSituation(situation);

      that.alertProvider.doAlert('Você não pode tirar cópia da tela. Isto faz parte da nova medida de segurança do sistema.', 'Atenção');
    });
  }

  private prepareCamera() {
    this.proofCameraProvider.initiate(
      this.proofProvider.getId(),
      this.question.id,
      (this.timer.seconds - this.timer.secondsRemaining), // Seconds
      this.timer.secondsRemaining
    );
  }

  private prepareAudio() {
    this.proofAudioProvider.initiate(
      this.proofProvider.getId(),
      this.question.id,
      (this.timer.seconds - this.timer.secondsRemaining),
      this.timer.secondsRemaining
    );
  }

  doAnswer() {
    let that = this;

    if (!that.paused) {
      if (this.answer === null) {
        let message = 'Sua pergunta não foi respondida. Deseja continuar sem resposta?';

        this.alertProvider.doConfirm(message, () => {
          that.doAnswerAndFetchNextQuestion();
        });
      } else {
        this.doAnswerAndFetchNextQuestion();
      }
    }
  }

  private doAnswerAndFetchNextQuestion() {
    this.proofProvider.addAnswer(this.question.id, this.answer);

    let nextQuestion = this.proofProvider.getNextQuestion();

    if (nextQuestion !== null) {
      this.takeSelfie();
      this.takeAudio();
      this.content.scrollToTop();

      this.answer = null;
      this.question = nextQuestion;
      this.questionIdx = this.proofProvider.getCurrentQuestionIdx();
      this.questionsTotal = this.proofProvider.getQuestionsTotal();
      this.questionSeconds = 0;
    } else {
      this.finishProof();
    }
  }

  finishProof() {
    this.proofFinished = true;
    this.pauseTimer();
    if (this.proofFinished) {
      //"{"id":"1591213283535","kind":"MV","name":null,"questionId":null,"note":null,"base64":null,"contentOrPath":"file:///storage/emulated/0/DCIM/Camera/VID_20200603_194118.mp4","captured":"2020-06-03T19:41:23+00:00","seconds":null,"secondsRemaining":null,"extra":null}"
      let dataEndProof = this.dateTimeProvider.getISOString();
      // {
      //   "id":this.dateTimeProvider.getString(),
      //   "kind":"POE",
      //   "name":null,
      //   "questionId":null,
      //   "note":null,
      //   "base64":null,
      //   "contentOrPath":null,
      //   "captured":this.dateTimeProvider.getISOString(),
      //   "seconds":null,
      //   "secondsRemaining":null,
      //   "extra":null
      // };
      this.storage.set('userproof_' + this.proof.getId() + '_atEndProof', dataEndProof);
    }
    this.proofProvider.setFinished();
    this.navCtrl.push(ProofAfterEndPage);
  }

  setRemaining() {
    let that = this;
    let remaining = that.timer.secondsRemaining;
    this.proofServerProvider.setRemaining(this.proofProvider.getId(), remaining);
  }

  private takeAudio() {
    let that = this;
    if ((this.proofProvider.hasProof()) && (!this.proofFinished) && (!that.paused)) {
      this.proofProvider.isFinished().subscribe((finished: boolean) => {
        if (!finished) {
          that.mediaProvider.takeAudio(
            that.question.id,
            (that.timer.seconds - that.timer.secondsRemaining),
            that.timer.secondsRemaining
          );
        }
      })
    }
  }

  private takeSelfie() {
    let that = this;

    if ((this.proofProvider.hasProof()) && (!this.proofFinished) && (!that.paused)) {

      this.proofProvider.isFinished().subscribe((finished: boolean) => {

        if (!finished) {

          that.proofCameraProvider.takeSelfie(
            that.question.id,
            (that.timer.seconds - that.timer.secondsRemaining), // Seconds
            that.timer.secondsRemaining
          );
        }
      });
    }
  }

  private incrementSecondsAndCouldTakePhoto() {
    this.questionSeconds++;

    // 20s, 2 min, 3 min, 4 min
    if ([20, 120, 180, 240].indexOf(this.questionSeconds) >= 0) {
      this.takeSelfie();
    }
  }

  // Timer stuff
  private initTimer() {
    if (!this.timeInSeconds) {
      this.timeInSeconds = 0;
    }

    this.timer = <ITimer>{
      seconds: this.timeInSeconds,
      runTimer: false,
      hasStarted: false,
      hasFinished: false,
      secondsRemaining: this.timeInSeconds
    };

    this.timer.displayTime = this.getSecondsAsDigitalClock(this.timer.secondsRemaining);
  }

  private startTimer() {
    this.timer.hasStarted = true;
    this.timer.runTimer = true;

    this.timerTick();
  }

  private pauseTimer() {
    this.timer.runTimer = false;
  }

  // private resumeTimer() {
  //   this.startTimer();
  // }

  private timerTick() {
    let that = this;

    setTimeout(() => {
      if (!that.timer.runTimer) {
        return;
      }

      that.timer.secondsRemaining--;
      that.proofProvider.setDuration(that.timer.secondsRemaining);
      that.timer.displayTime = that.getSecondsAsDigitalClock(that.timer.secondsRemaining);

      that.incrementSecondsAndCouldTakePhoto();

      if (that.timer.secondsRemaining > 0) {
        that.timerTick();
      } else {
        that.timer.hasFinished = true;
        that.finishProof();
      }
    }, 1000);
  }

  private getSecondsAsDigitalClock(inputSeconds: number) {
    let sec_num = parseInt(inputSeconds.toString(), 10); // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);
    let hoursString = '';
    let minutesString = '';
    let secondsString = '';

    hoursString = (hours < 10) ? '0' + hours : hours.toString();
    minutesString = (minutes < 10) ? '0' + minutes : minutes.toString();
    secondsString = (seconds < 10) ? '0' + seconds : seconds.toString();

    return hoursString + ':' + minutesString + ':' + secondsString;
  }

  private checkPaused() {
    if ((this.proofProvider.hasProof()) && (this.paused)) {

      // TODO: Send situation to server automatically

      let situation = new QuestionSituation();
      situation.kind = 'QTS';
      situation.id = this.question.id;
      situation.captured = this.dateTimeProvider.getISOString();
      situation.action = 'EFTB'; // 'ExitedFrom(Window)Tab';
      this.proofProvider.addSituation(situation);

      this.alertProvider.doAlert('Você saiu da tela de prova de certificação. Conforme regras do edital o candidato não pode fazer consulta a terceiros ou outros materiais, podendo ser reprovado caso insista nessa prática. Caso você esteja com problemas relacionado à aplicação, favor entrar em contato no telefone (11) 3372-9572 - opção 1.', 'Atenção');
      this.paused = false;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProofOnAppPage');

    let that = this;

    this.platform.ready().then(() => {
      that.pauseSubscribe = that.platform.pause.subscribe(() => {
        that.paused = true;
      });
      that.resumeSubscribe = that.platform.resume.subscribe(() => {
        that.checkPaused();
      });
    });
  }

  ionViewWillUnload() {
    console.log('ionViewWillUnload ProofOnAppPage');

    this.screenshotListener();
    this.pauseSubscribe.unsubscribe();
    this.resumeSubscribe.unsubscribe();
    this.proofCameraProvider.destroy();
  }

}



// WEBPACK FOOTER //
// ./src/pages/proof-on-app/proof-on-app.ts